import React from "react";

/** Figma 10231:3947 — Union plus */
export default function NavPlusIcon({ color = "#417B5A" }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="9"
            height="9"
            viewBox="0 0 8.70117 8.74023"
            fill="none"
            aria-hidden="true"
            style={{ display: "block" }}
        >
            <path
                d="M5.16602 3.52539H8.70117V5.14648H5.16602V8.74023H3.54492V5.14648H0V3.52539H3.54492V0H5.16602V3.52539Z"
                fill={color}
            />
        </svg>
    );
}
